/**
 * Describes all composite index's options.
 */
export interface IndexOptions {

    /**
     * Indicates if this composite index must be unique or not.
     */
    readonly unique?: boolean;

}